import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Galerie from "@/pages/Galerie";
import FAQ from "@/pages/FAQ";
import Temoignages from "@/pages/Temoignages";
import VillePage from "@/pages/VillePage";
import ServicePage from "@/pages/ServicePage";
import ServiceVillePage from "@/pages/ServiceVillePage";
import SuiviSEO from "@/pages/SuiviSEO";
import AgentSEO from "@/pages/AgentSEO";
import MentionsLegales from "@/pages/MentionsLegales";
import seoData from "@/data/seoVilles.json";

// Liste des villes valides pour le routage dynamique (source unique : seoVilles.json)
const VALID_VILLES = seoData.villes.map((v) => v.slug);

// Composant wrapper pour les pages villes (valide si ville existe)
function VilleWrapper() {
  return <VillePage />;
}

// Composant wrapper pour les pages services
function ServiceWrapper() {
  return <ServicePage />;
}

function App() {
  // Tracking des clics sur les numéros de téléphone (par page)
  useEffect(() => {
    const handler = (e) => {
      const link = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (!link) return;
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/call-click`;
      const payload = JSON.stringify({ page: window.location.pathname });
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
        } else {
          fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
        }
      } catch (err) { /* silencieux */ }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Pages statiques */}
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:articleId" element={<BlogArticle />} />
        <Route path="/galerie" element={<Galerie />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/temoignages" element={<Temoignages />} />
        <Route path="/suivi-seo" element={<SuiviSEO />} />
        <Route path="/agent-seo" element={<AgentSEO />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/contact" element={<Home />} />
        
        {/* Pages services (statiques pour SEO) */}
        <Route path="/desinsectisation" element={<ServiceWrapper />} />
        <Route path="/deratisation" element={<ServiceWrapper />} />
        <Route path="/desinfection" element={<ServiceWrapper />} />
        <Route path="/punaises-de-lit" element={<ServiceWrapper />} />
        
        {/* Route dynamique pour Service+Ville (ex: /deratisation-nice) */}
        <Route path="/:slug" element={<DynamicPage />} />
      </Routes>
    </BrowserRouter>
  );
}

// Composant qui route dynamiquement vers VillePage ou ServiceVillePage
function DynamicPage() {
  const path = window.location.pathname.replace(/^\//, "").replace(/\/$/, "");
  
  // Si c'est une ville simple (ex: /nice)
  if (VALID_VILLES.includes(path)) {
    return <VillePage />;
  }
  
  // Si c'est un service+ville (ex: /deratisation-nice, /destruction-nid-guepe-frelon-antibes)
  const serviceVillePatterns = [
    ...seoData.services.map((s) => `${s.slug}-`),
    "punaise-de-lit-"
  ];
  
  for (const pattern of serviceVillePatterns) {
    if (path.startsWith(pattern)) {
      const ville = path.replace(pattern, "");
      if (VALID_VILLES.includes(ville)) {
        return <ServiceVillePage />;
      }
    }
  }
  
  // Page 404 si rien ne correspond
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-gray-600 mb-6">Page non trouvée</p>
        <a href="/" className="text-emerald-600 hover:underline font-medium">
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
}

export default App;
